/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import template from './trigger-form.component.html';
import {AppSharedModule} from '../common/app-shared.module';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {MATCHING_STYLES, SPECIAL_BEHAVIOUR_DOMAIN_TYPES, TriggerFormLogic} from './trigger-form-logic';

@Component({
  standalone: true,
  imports: [
    AppSharedModule,
    FormsModule,
    ButtonsModule,
    BsDatepickerModule,
    AdnSelectComponent,
    FormControlsModule
  ],
  selector: 'adn-trigger-form',
  template
})
export class TriggerFormComponent {
  @Input() logic: TriggerFormLogic;

  @Output() changed = new EventEmitter<void>();

  readonly matchingStyles = MATCHING_STYLES;
  readonly specialBehaviourDomainTypes = SPECIAL_BEHAVIOUR_DOMAIN_TYPES;
  readonly datePickerConfig = {
    dateInputFormat: 'YYYY-MM-DD',
    containerClass: 'theme-blue',
    showWeekNumbers: false,
    adaptivePosition: true
  };

  getOperationHelp(criterion: any): string {
    const fieldName = criterion?.name;
    const operationId = criterion?.operation?.id;
    if (!fieldName || !operationId) {
      return '';
    }
    return this.logic?.nameOpHelp?.[fieldName]?.[operationId] || '';
  }
}
